// Store de alerta global — popup cartoon com botao "OK, entendi".
// Substitui faixas de erro feias inline (Felipe 2026-05-31).
//
// Uso:
//   import { showAlert } from '../stores/alert';
//   showAlert('mensagem', { title: 'Opa!', tone: 'warn' });

import { writable } from 'svelte/store';

export type AlertTone = 'info' | 'warn' | 'error' | 'success';

export type AlertState = {
  open: boolean;
  title: string;
  message: string;
  tone: AlertTone;
  okLabel: string;
};

const initial: AlertState = {
  open: false,
  title: '',
  message: '',
  tone: 'info',
  okLabel: 'OK, entendi',
};

export const alertState = writable<AlertState>({ ...initial });

export function showAlert(
  message: string,
  opts?: { title?: string; tone?: AlertTone; okLabel?: string },
): void {
  alertState.set({
    open: true,
    message,
    title: opts?.title ?? defaultTitle(opts?.tone ?? 'info'),
    tone: opts?.tone ?? 'info',
    okLabel: opts?.okLabel ?? 'OK, entendi',
  });
}

export function dismissAlert(): void {
  alertState.update((s) => ({ ...s, open: false }));
}

function defaultTitle(tone: AlertTone): string {
  switch (tone) {
    case 'warn':
      return 'Atenção';
    case 'error':
      return 'Ops!';
    case 'success':
      return 'Pronto!';
    default:
      return 'Aviso';
  }
}
